import type { PublicDictionary } from "./types";

export const id: PublicDictionary = {
  meta: {
    title: "bizy — Kasir & Manajemen Pesanan",
    description:
      "Aplikasi kasir, pesanan, dan inventaris multi-tenant untuk bisnis rental, katering, dan retail. Proses checkout, kelola DP, dan bagikan invoice dalam hitungan detik.",
    keywords: "aplikasi kasir, POS, manajemen pesanan, inventaris, invoice, rental, multi-tenant",
  },
  nav: {
    features: "Fitur",
    workflow: "Cara kerja",
    pricing: "Harga",
    signIn: "Masuk",
    dashboard: "Dashboard",
    startProject: "Mulai proyek",
    language: "Bahasa",
  },
  hero: {
    badge: "Dibuat untuk rental, katering, dan retail",
    title: "Kelola kasir,",
    highlight: "bukan spreadsheet.",
    description:
      "bizy menyatukan katalog, checkout, DP, dan invoice dalam satu workspace — setiap pesanan terekam, setiap invoice mudah dibagikan.",
    primaryCta: "Mulai proyek",
    secondaryCta: "Buka dashboard",
    stats: [
      { value: "Lunas & DP", label: "Mode pembayaran" },
      { value: "A4 · Letter · 80mm", label: "Ukuran invoice" },
      { value: "PNG + cetak", label: "Siap dibagikan" },
    ],
  },
  features: {
    title: "Semua yang dibutuhkan kasir",
    description:
      "Produk, varian, pesanan, pembayaran, dan invoice — terisolasi per workspace, dijaga oleh scope.",
    items: [
      {
        title: "Multi-tenant sejak awal",
        description: "Setiap workspace memiliki produk, pesanan, anggota, dan jejak audit sendiri.",
      },
      {
        title: "Lunas atau DP",
        description: "Terima pembayaran penuh atau DP, lalu tagih sisanya — angka selalu presisi.",
      },
      {
        title: "Peran granular",
        description: "Tujuh peran workspace, dicek di server dan di RLS Postgres.",
      },
      {
        title: "Audit menyeluruh",
        description: "Setiap create, update, dan delete menulis event workspace yang bisa ditinjau.",
      },
      {
        title: "Gambar invoice",
        description: "Render invoice sesuai permintaan, simpan, dan bagikan lewat tautan stabil.",
      },
      {
        title: "Siap cetak",
        description: "A4, Letter, atau thermal 80mm — tata letak mengikuti ukuran yang dipilih.",
      },
    ],
  },
  workflow: {
    title: "Dari keranjang sampai lunas",
    description: "Satu alur, baik pelanggan membayar penuh maupun memberi DP.",
    steps: [
      { title: "Pilih produk", description: "Pilih produk dan variannya, lalu tentukan jumlah." },
      { title: "Tentukan pembayaran", description: "Terima pembayaran penuh atau catat uang muka." },
      { title: "Terbitkan invoice", description: "Buat gambar invoice lalu bagikan lewat WhatsApp atau email." },
      { title: "Tagih sisanya", description: "Buka pesanan, lunasi sisa, dan terbitkan invoice pelunasan." },
    ],
  },
  plans: {
    title: "Paket",
    description: "Mulai gratis. Pro membuka produk, pesanan, dan anggota tanpa batas.",
    free: {
      title: "Free",
      description: "Satu pengguna, 25 produk, 20 pesanan per hari, produk satu varian.",
    },
    pro: {
      title: "Pro",
      description: "Produk dan pesanan tanpa batas, anggota tim, varian kustom, laporan lanjutan.",
    },
    cta: "Pilih paket",
    comingSoon: "Checkout segera hadir",
  },
  cta: {
    title: "Buka workspace hari ini",
    description: "Masuk dengan Google, pilih paket, dan mulai menerbitkan invoice dalam beberapa menit.",
    primary: "Mulai proyek",
    secondary: "Masuk",
  },
  footer: {
    tagline: "Kasir, pesanan, dan inventaris — dalam satu workspace.",
    rights: "Seluruh hak dilindungi.",
    product: "Produk",
    resources: "Sumber daya",
    legal: "Legal",
  },
  auth: {
    title: "Masuk ke bizy",
    description: "Lanjutkan dengan Google untuk membuka dashboard workspace Anda.",
    google: "Lanjutkan dengan Google",
    disclaimer: "Dengan melanjutkan Anda menyetujui ketentuan dan kebijakan privasi workspace.",
    retry: "Coba lagi",
  },
  invoice: {
    title: "Invoice",
    billTo: "Ditagihkan kepada",
    invoiceNumber: "Nomor invoice",
    issuedAt: "Diterbitkan",
    dueAt: "Jatuh tempo",
    qty: "Jumlah",
    price: "Harga",
    amount: "Total",
    subtotal: "Subtotal",
    tax: "Pajak",
    total: "Total",
    paid: "Dibayar",
    balance: "Sisa",
    status: "Status",
    pageSize: "Ukuran halaman",
    print: "Cetak",
    download: "Unduh",
    shareWhatsApp: "Bagikan ke WhatsApp",
    shareEmail: "Bagikan lewat email",
    settlementType: "Pembayaran",
    fullSettlement: "Lunas",
    downPayment: "Uang muka",
    balanceInvoice: "Invoice pelunasan",
  },
  errors: {
    generic: "Terjadi kesalahan. Silakan coba lagi.",
    unauthorized: "Anda perlu masuk untuk melanjutkan.",
    notFound: "Yang Anda cari tidak ditemukan.",
  },
};
